export const profile = {
  nameFirst: "ANDREW",
  nameLast: "MCMULLIN",
  subtitle: "FULL-STACK ENGINEER / CREATIVE TECHNOLOGIST",
  intro:
    "I build full-stack systems, AI workflows, and internal tools with a focus on speed, maintainability, and production readiness.",
  email: "mcmullinand@gmail.com",
  linkedin: "https://www.linkedin.com/in/andrew-mcmullin",
  github: "https://github.com/mcmullinboy15",
  resume: "/assets/Resume.pdf",
};

export const stats = [
  { label: "Years Building" },
  { label: "Projects Shipped" },
  { label: "Degrees" },
  { label: "Startups" },
];

export const experiences = [
  {
    id: "remi",
    title: "Software Engineer",
    company: "Remi",
    subtitle: "Remi",
    companyType: "startup",
    employmentType: "full-time",
    featured: true,
    startDate: new Date("2024-12-09"),
    endDate: new Date("2026-03-18"),
    description: [
      "Simplifying roofing for homeowners, roofers, and enterprises.",
      "Built new features across AI, Finance, Accounting, Operations, Contractors, and Mobile.",
    ],
    tags: ["ai-ml", "llm-workflows", "prompt-engineering", "full-stack", "frontend", "backend", "mobile", "data-systems", "databases-sql"],
  },
  {
    id: "origin",
    title: "Full-Stack Engineer",
    company: "Origin",
    subtitle: "Origin",
    companyType: "startup",
    employmentType: "full-time",
    featured: false,
    startDate: new Date("2023-12-04"),
    endDate: new Date("2024-12-06"),
    description: [
      "Creative technology company building zero-code CTV ad formats.",
      "Delivered dynamic, responsive ad experiences for brands and agencies.",
    ],
    tags: ["full-stack", "frontend", "cloud-devops", "databases-sql"],
  },
  {
    id: "rakemail",
    title: "Software Engineer",
    company: "Rakemail",
    subtitle: "Rakemail",
    companyType: "startup",
    employmentType: "part-time",
    featured: false,
    startDate: new Date("2024-05-01"),
    endDate: new Date("2024-08-12"),
    description: [
      "Building an email marketing platform for small businesses.",
      "Enabling cart recovery and campaign automation.",
    ],
    tags: ["backend", "full-stack", "databases-sql"],
  },
  {
    id: "freelance",
    title: "Software Engineer",
    company: "Freelance",
    subtitle: "Freelance",
    companyType: "independent",
    employmentType: "contract",
    featured: false,
    startDate: new Date("2020-06-01"),
    endDate: null,
    description: [
      "Spark A Change: landing page, donate flow, and trip portal (sparkachange.org).",
      "Podflow: AI-generated show notes, transcripts, blogs, and social content.",
      "PRC Links: training videos and textbook resources for planar linkage synthesis.",
      "Automated payroll for GoalHome LLC; 4+ hours to 5 minutes.",
      "Project lead for podcast automation startup (React, Express, DynamoDB).",
      "Nonprofit UI and secure video streaming experiences.",
    ],
    tags: ["full-stack", "frontend", "backend", "cloud-devops", "data-systems", "developer-tooling"],
  },
  {
    id: "ezsalt",
    title: "Co-Founder & CTO",
    company: "EZsalt",
    subtitle: "EZsalt",
    companyType: "startup",
    employmentType: "founder",
    featured: true,
    startDate: new Date("2019-11-01"),
    endDate: new Date("2021-07-31"),
    description: [
      "Built micro-controller for monitoring water-softener salt levels on your phone.",
      "300+ users, 0 failures, 3+ years; scalable to thousands of customers.",
    ],
    tags: ["full-stack", "mobile", "iot", "cloud-devops", "databases-sql"],
    links: [
      { label: "ezsalt.com", href: "https://ezsalt.com" },
    ],
  },
  {
    id: "pse",
    title: "Controls Engineer 1",
    company: "Precision Systems Engineering",
    subtitle: "Precision Systems Engineering",
    companyType: "company",
    employmentType: "full-time",
    featured: false,
    startDate: new Date("2023-03-01"),
    endDate: new Date("2023-12-01"),
    description: [
      "Ignition-based HMI for a mineral plant with HTTPS data API.",
      "Custom CRM workflow for Outlook add-in (React, Express, Azure).",
    ],
    tags: ["full-stack", "backend", "data-systems", "databases-sql"],
  },
  {
    id: "apple",
    title: "Full-Stack Engineer",
    company: "Apple",
    subtitle: "Apple",
    companyType: "company",
    employmentType: "intern",
    featured: true,
    startDate: new Date("2022-05-16"),
    endDate: new Date("2022-08-12"),
    description: [
      "Rebuilt a 10-year-old internal platform for Hardware Tech’s Compiled Memory engineers and shipped it to production in 3 months.",
      "Prioritized maintainability and delivery reliability while increasing response speed and eliminating blocking error notifications.",
    ],
    tags: ["full-stack", "frontend", "cloud-devops", "systems-engineering", "developer-tooling"],
  },
  {
    id: "optima",
    title: "Backend Engineer",
    company: "Optima Powerware",
    subtitle: "Optima Powerware",
    companyType: "startup",
    employmentType: "intern",
    featured: false,
    startDate: new Date("2021-07-01"),
    endDate: new Date("2021-08-12"),
    description: [
      "Backend management for goldmine automation and ML controls.",
      "React + Django API rebuild for scalability.",
    ],
    tags: ["ai-ml", "backend", "databases-sql"],
  },
  {
    id: "optima-ml",
    title: "Machine Learning Engineer",
    company: "Optima Powerware",
    subtitle: "Optima Powerware",
    companyType: "startup",
    employmentType: "intern",
    featured: true,
    startDate: new Date("2020-05-01"),
    endDate: new Date("2020-08-31"),
    description: [
      "Predicted goldmine output quality, eliminating manual sampling.",
      "Built a PyTorch neural network (5 layers, 16-to-1 features) using multi-sensor inputs.",
    ],
    tags: ["ai-ml", "data-systems"],
  },
  {
    id: "instructure",
    title: "Junior QA Engineer",
    company: "Instructure",
    subtitle: "Instructure",
    companyType: "company",
    employmentType: "intern",
    featured: false,
    startDate: new Date("2019-07-01"),
    endDate: new Date("2020-05-01"),
    description: [
      "Performed testing and quality checks on new commits and products.",
      "Tools: Git, Jira.",
    ],
    tags: ["full-stack"],
  },
];

export const education = [
  {
    id: "umich",
    title: "University of Michigan",
    subtitle: "M.S. in Computer Science and Engineering",
    description: [
      "AI/ML-focused coursework including Machine Learning, AI Foundations, Applied ML for Affective Computing, and Artificial General Intelligence.",
      "Additional depth in Advanced Cryptography, Parallel Computing, Advanced Compilers, and User Interface Development.",
    ],
  },
  {
    id: "usu",
    title: "Utah State University",
    subtitle: "B.S. in Computer Science",
    description: [
      "ML for clean energy: modeled solar-battery scheduling strategies (CS 5620).",
      "Data science + visualization: interactive analytics for large datasets (CS 5820).",
      "Algorithms + cloud systems: reinforced ML pipeline performance and deployment literacy (CS 5050, CS 5890).",
    ],
  },
];

export const tagDefinitions = {
  "ai-ml": { label: "AI / ML" },
  "affective-computing": { label: "Affective Computing" },
  "cog-sci": { label: "Cognitive Science" },
  "full-stack": { label: "Full-Stack Engineering" },
  frontend: { label: "Frontend" },
  backend: { label: "Backend" },
  "databases-sql": { label: "Databases / SQL" },
  "developer-tooling": { label: "Developer Tooling" },
  "cloud-devops": { label: "Cloud / DevOps" },
  mobile: { label: "Mobile" },
  iot: { label: "IoT" },
  "data-systems": { label: "Data / Analytics" },
  security: { label: "Security" },
  "systems-engineering": { label: "Systems Engineering" },
  compilers: { label: "Compilers" },
  parallel: { label: "Parallel Computing" },
  leadership: { label: "Leadership" },
  core: { label: "Core CS" },
  industry: { label: "Industry" },
  research: { label: "Research" },
  math: { label: "Mathematics" },
  algorithms: { label: "Algorithms" },
  energy: { label: "Energy" },
};

export const courses = [
  {
    id: "eecs583",
    title: "EECS 583 - Advanced Compilers",
    school: "umich",
    tags: ["systems-engineering", "compilers"],
    doc: "/assets/583_Project_Final_Report.pdf",
  },
  {
    id: "eecs587",
    title: "EECS 587 - Parallel Computing",
    school: "umich",
    tags: ["systems-engineering", "parallel"],
    doc: "/assets/EECS_587__Term_Project_Report.pdf",
  },
  {
    id: "eecs592",
    title: "EECS 592 - AI Foundations",
    school: "umich",
    tags: ["ai-ml"],
    doc: "/assets/EECS_592_Project_Final_Report.pdf",
  },
  {
    id: "eecs545",
    title: "EECS 545 - Machine Learning",
    school: "umich",
    tags: ["ai-ml", "math", "data-systems"],
    doc: "/assets/EECS545_Project.pdf",
  },
  {
    id: "eecs598_encrypted",
    title: "EECS 598 - Encrypted Systems",
    school: "umich",
    tags: ["security"],
    doc: "/assets/598_007_final_report.pdf",
  },
  {
    id: "eecs598_affective",
    title: "EECS 598 - Applied ML for Affective Computing",
    school: "umich",
    tags: ["ai-ml", "affective-computing"],
    doc: "/assets/EECS598_010_FinalProject.pdf",
  },
  {
    id: "eecs598_agi",
    title: "EECS 598 - Artificial General Intelligence",
    school: "umich",
    tags: ["ai-ml", "cog-sci"],
    doc: "/assets/EECS_598__AGI__Final.pdf",
  },
  {
    id: "eecs493",
    title: "EECS 493 - User Interface Dev",
    school: "umich",
    tags: ["frontend"],
  },
  {
    id: "eecs575",
    title: "EECS 575 - Advanced Cryptography",
    school: "umich",
    tags: ["security"],
  },
  {
    id: "entr550",
    title: "ENTR 550 - Interpersonal Skills",
    school: "umich",
    tags: ["leadership"],
  },
  {
    id: "cs2410",
    title: "CS 2410 - Intro to Event-Driven Prog & GUIs",
    school: "usu",
    tags: ["full-stack", "frontend"],
  },
  { id: "cs2420", title: "CS 2420 - Computer Science 3", school: "usu", tags: ["core"] },
  { id: "cs4250", title: "CS 4250 - Cooperative Work Experience", school: "usu", tags: ["industry"] },
  { id: "cs1440", title: "CS 1440 - Methods in CS", school: "usu", tags: ["core"] },
  { id: "cs2610", title: "CS 2610 - Developing Web Applications", school: "usu", tags: ["full-stack", "frontend"] },
  { id: "cs5890_devops", title: "CS 5890 - Intro DevOps and Cloud-Based", school: "usu", tags: ["cloud-devops", "developer-tooling"] },
  { id: "cs3450", title: "CS 3450 - Intro Software Engr", school: "usu", tags: ["full-stack"] },
  { id: "cs4700", title: "CS 4700 - Program Languages", school: "usu", tags: ["backend", "developer-tooling", "systems-engineering"] },
  { id: "cs5800", title: "CS 5800 - Intro to Database Systems", school: "usu", tags: ["backend", "databases-sql", "data-systems"] },
  {
    id: "cs5820",
    title: "CS 5820 - Data Science Data Vis",
    school: "usu",
    tags: ["data-systems", "frontend"],
    doc: "/assets/CS5820 FinalProject_Proposal.pdf",
  },
  { id: "cs3100", title: "CS 3100 - OS and Concurrency", school: "usu", tags: ["systems-engineering"] },
  {
    id: "cs3200",
    title: "CS 3200 - Mobile Application Dev",
    school: "usu",
    tags: ["frontend", "mobile"],
    doc: "/assets/3200_Project_1_Purposal.pdf",
  },
  { id: "cs4950", title: "CS 4950 - Undergraduate Research", school: "usu", tags: ["research"] },
  { id: "cs5050", title: "CS 5050 - Adv Algorithms", school: "usu", tags: ["algorithms", "backend", "data-systems"] },
  { id: "cs5620", title: "CS 5620 - AI in Clean Energy", school: "usu", tags: ["ai-ml", "data-systems", "energy"] },
  { id: "cs5890_cloud", title: "CS 5890 - Develop Cloud-Based Software", school: "usu", tags: ["cloud-devops", "full-stack"] },
  { id: "cs5890_intro", title: "CS 5890 - Intro to Cloud Computing", school: "usu", tags: ["cloud-devops"] },
  { id: "math5710", title: "MATH 5710 - Intro to Probability", school: "usu", tags: ["math", "data-systems"] },
  { id: "math2250", title: "MATH 2250 - Linear Alg/Diff Equations", school: "usu", tags: ["math", "data-systems"] },
  { id: "math3310", title: "MATH 3310 - Discrete Mathematics", school: "usu", tags: ["math"] },
  { id: "math2210", title: "MATH 2210 - Multivariable Calculus", school: "usu", tags: ["math"] },
];

export const skillDefinitions = [
  { id: "ai-ml", name: "AI / ML", tools: ["PyTorch", "Python", "LangChain"] },
  { id: "llm-workflows", name: "LLM Workflows", tools: ["Claude", "LangChain", "Automation"] },
  { id: "prompt-engineering", name: "Prompt Engineering", tools: ["Claude", "Evaluation", "AI UX"] },
  { id: "data-systems", name: "Data / Analytics", tools: ["Pandas", "NumPy", "Visualization"] },
  { id: "full-stack", name: "Full-Stack Engineering", tools: ["React", "Vue", "Node.js"] },
  { id: "backend", name: "Backend", tools: ["Express", "Django", "Go"] },
  { id: "cloud-devops", name: "Cloud / DevOps", tools: ["Docker", "AWS", "Firebase"] },
  { id: "databases-sql", name: "Databases / SQL", tools: ["SQL", "DynamoDB", "Firestore"] },
  { id: "mobile", name: "Mobile", tools: ["React Native", "Expo", "iOS"] },
  { id: "iot", name: "IoT", tools: ["ESP", "Sensors", "Embedded"] },
  { id: "developer-tooling", name: "Developer Tooling", tools: ["Python", "GitHub", "Automation"] },
  { id: "systems-engineering", name: "Systems Engineering", tools: ["CUDA", "Compilers", "Parallel"] },
  { id: "security", name: "Security", tools: ["Cryptography", "Encryption", "Integrity"] },
];

export const projects = [  {
    id: "claude-auto",
    title: "Claude Auto",
    category: "AI Workflow Tooling",
    year: "2026",
    description:
      "Automated personal project workflows and audit loops for AI-assisted development.",
    tags: ["ai-ml", "llm-workflows", "prompt-engineering", "cloud-devops", "developer-tooling"],
    relatedExperience: ["remi"],
    relatedCourses: [],
  },
  {
    id: "remi-mobile-photo",
    title: "Mobile Photo Submission",
    category: "Mobile",
    year: "2025",
    description:
      "Solo-built a photo evidence workflow in Expo + React Native with authenticated deep links that open the Remi app, auto-create/login users, and guide them through a question-by-question checklist with a custom camera UI. Each question (photo, text, and multi-choice) feeds a live review queue for approval/denial, enabling real-time OSHA safety verification and rapid rework while contractors are still on site, targeting a five-minute review window.",
    tags: ["frontend", "mobile"],
    relatedExperience: ["remi"],
    relatedCourses: [],
  },
  {
    id: "apple-compiled-memory",
    title: "Compiled Memory Internal Platform",
    category: "Full-Stack Platform",
    year: "2022",
    description:
      "Rebuilt a 10-year-old internal platform for Apple Hardware Tech’s Compiled Memory engineers and shipped it to production in 3 months. Prioritized maintainability and delivery reliability while increasing response speed and eliminating blocking error notifications.",
    tags: ["full-stack", "frontend", "cloud-devops", "developer-tooling", "systems-engineering"],
    relatedExperience: ["apple"],
    relatedCourses: [],
  },
  {
    id: "ezsalt",
    title: "EZsalt",
    category: "IoT Product",
    year: "2021",
    description: "Water-softener salt monitoring with mobile alerts.",
    tags: ["full-stack", "mobile", "iot", "cloud-devops", "databases-sql"],
    relatedExperience: ["ezsalt"],
    relatedCourses: [],
    links: [
      { label: "ezsalt.com", href: "https://ezsalt.com" },
    ],
  },
  {
    id: "optima-goldmine-quality",
    title: "Goldmine Output Quality Model",
    category: "Machine Learning",
    year: "2020",
    description:
      "PyTorch neural network predicting goldmine output quality. Reduced manual sampling with automated model inference.",
    tags: ["ai-ml", "data-systems"],
    relatedExperience: ["optima-ml"],
    relatedCourses: [],
  },
  {
    id: "remi-accounting-accrual",
    title: "Accounting Accrual Logic",
    category: "Finance Systems",
    year: "2025",
    description:
      "Implemented accrual logic to support accurate accounting and reporting workflows.",
    tags: ["backend", "databases-sql"],
    relatedExperience: ["remi"],
    relatedCourses: [],
    featured: false,
  },
  {
    id: "rakemail-campaign-automation",
    title: "Campaign Automation",
    category: "Email Platform",
    year: "2024",
    description:
      "Built campaign automation workflows for small-business email marketing, including cart recovery and lifecycle messaging.",
    tags: ["backend", "full-stack", "databases-sql"],
    relatedExperience: ["rakemail"],
    relatedCourses: [],
    featured: false,
  },
  {
    id: "remi-milestone-dashboard",
    title: "Project Milestone Dashboard",
    category: "Product Analytics",
    year: "2025",
    description:
      "Built a dashboard to track milestones, delivery status, and cross-team dependencies.",
    tags: ["backend", "data-systems", "databases-sql"],
    relatedExperience: ["remi"],
    relatedCourses: [],
    featured: false,
  },
  {
    id: "remi-langchain-infra",
    title: "LangChain AI Infrastructure",
    category: "AI Infrastructure",
    year: "2025",
    description:
      "Designed and maintained LangChain-based AI infrastructure for internal product use.",
    tags: ["ai-ml", "llm-workflows"],
    relatedExperience: ["remi"],
    relatedCourses: [],
    featured: false,
  },
  {
    id: "remi-taskflow-ktlo",
    title: "Taskflow Maintenance (KTLO)",
    category: "Operations",
    year: "2025",
    description:
      "Owned ongoing Taskflow maintenance and operational reliability improvements.",
    tags: ["backend"],
    relatedExperience: ["remi"],
    relatedCourses: [],
    featured: false,
  },
  {
    id: "encrypted-systems",
    title: "Encrypted Systems Final Project",
    category: "Security Research",
    year: "2023",
    description:
      "Analyzed bit-flipping effects on MySQL encrypted .ibd files and common schemes.",
    tags: ["security"],
    github:
      "https://github.com/mcmullinboy15/598_007_Encrypted_Systems_Final_Project",
    relatedExperience: [],
    relatedCourses: ["eecs598_encrypted"],
    featured: false,
  },
  {
    id: "tvm-compiler",
    title: "TVM Compiler Extensions",
    category: "Compilers",
    year: "2021",
    description: "Extended operator fusion for EECS 583.",
    tags: ["systems-engineering"],
    github: "https://github.com/mcmullinboy15/tvm",
    relatedExperience: [],
    relatedCourses: ["eecs583"],
    featured: false,
  },
  {
    id: "bagel-bunch",
    title: "Bagel Bunch",
    category: "Web App",
    year: "2022",
    description: "Bagel shop ordering software (class project).",
    tags: ["full-stack", "frontend"],
    github: "https://github.com/mcmullinboy15/BagelBunch",
    link: "https://bagelbunch-b5e21.web.app",
    relatedExperience: [],
    relatedCourses: ["cs2610"],
    featured: false,
  },
  {
    id: "solar-scheduling",
    title: "Solar Scheduling",
    category: "Data + Optimization",
    year: "2022",
    description:
      "Scheduling solar energy usage between home consumption and battery storage.",
    tags: ["ai-ml", "data-systems"],
    github: "https://github.com/mcmullinboy15/6620_Solar_Energy_Project",
    relatedExperience: [],
    relatedCourses: ["cs5620"],
    featured: false,
  },
  {
    id: "uno",
    title: "UNO Game",
    category: "Full-Stack",
    year: "2021",
    description: "Full-stack UNO game with cloud platform integrations.",
    tags: ["full-stack", "cloud-devops"],
    github: "https://github.com/mcmullinboy15/uno",
    relatedExperience: [],
    relatedCourses: ["cs5890_cloud"],
    featured: false,
  },
  {
    id: "eecs598-010",
    title: "Food Analysis Pipeline",
    category: "Computer Vision",
    year: "2022",
    description:
      "Built a computer-vision pipeline for meal analysis, using Detectron2 to isolate food regions and a PyTorch multi-head model to predict calories and macronutrients from cropped images.",
    tags: ["ai-ml", "data-systems"],
    github: "https://github.com/mcmullinboy15/EECS598-010",
    relatedExperience: [],
    relatedCourses: ["eecs598_affective"],
  },
  {
    id: "goalhome",
    title: "GoalHome Payroll Automation",
    category: "Business Automation",
    year: "2020",
    description: "Automated payroll with overtime and day/night pay rules.",
    tags: ["full-stack", "backend", "data-systems", "databases-sql"],
    github: "https://github.com/mcmullinboy15/GoalHome",
    link: "https://goalhome.mcmullin.app/",
    relatedExperience: ["freelance"],
    relatedCourses: [],
  },
  {
    id: "portfolio",
    title: "This Portfolio",
    category: "Web App",
    year: "2024",
    description: "Vue-based portfolio with a custom design system.",
    tags: ["full-stack", "frontend", "cloud-devops", "developer-tooling"],
    github: "https://github.com/mcmullinboy15/portfolio",
    relatedExperience: ["freelance"],
    relatedCourses: [],
    featured: false,
  },
  {
    id: "flash-esp",
    title: "Flash Multiple ESP Devices",
    category: "IoT Tooling",
    year: "2021",
    description: "Python script to flash multiple ESP devices using esptool.",
    tags: ["iot"],
    github: "https://github.com/mcmullinboy15/flash-multiple-esp-devices",
    relatedExperience: ["freelance"],
    relatedCourses: [],
    featured: false,
  },
  {
    id: "crossover-js",
    title: "Crossover JS",
    category: "Developer Tooling",
    year: "2024",
    description: "Bridging the gap between frontend and backend.",
    tags: ["full-stack", "backend", "developer-tooling"],
    github: "https://github.com/mcmullinboy15/crossover-js",
    relatedExperience: ["freelance"],
    relatedCourses: [],
    featured: false,
  },
  {
    id: "canvas-python",
    title: "canvas-python",
    category: "Developer Tooling",
    year: "2020",
    description: "Python package for Canvas LMS API.",
    tags: ["backend", "developer-tooling"],
    github: "https://github.com/mcmullinboy15/canvas-python",
    relatedExperience: ["freelance"],
    relatedCourses: [],
    featured: false,
  },
  {
    id: "vue-firebase-template",
    title: "Vue Firebase Template",
    category: "Starter Kit",
    year: "2020",
    description: "Vue + Firebase template with auth and database setup.",
    tags: ["cloud-devops", "full-stack", "developer-tooling"],
    github: "https://github.com/mcmullinboy15/vue-firebase-template",
    relatedExperience: ["freelance"],
    relatedCourses: [],
    featured: false,
  },
  {
    id: "neows",
    title: "NeoWs Visualization",
    category: "Data Visualization",
    year: "2021",
    description: "NASA NEO data visualization and exploration.",
    tags: ["frontend", "data-systems"],
    github: "https://github.com/mghoffmann/NeoWs_visualization",
    relatedExperience: [],
    relatedCourses: ["cs5820"],
    featured: false,
  },
  {
    id: "family-gift-planner",
    title: "Family Gift Planner",
    category: "Mobile App",
    year: "2020",
    description: "Coordinated gift lists with shared visibility and checks.",
    tags: ["frontend", "mobile"],
    github: "https://github.com/mcmullinboy15/family_gift_planner",
    relatedExperience: [],
    relatedCourses: ["cs3200"],
    featured: false,
  },
  {
    id: "trail-tracker",
    title: "Trail Tracker App",
    category: "Mobile App",
    year: "2020",
    description: "Track hikes, route lengths, and photo history.",
    tags: ["frontend", "mobile"],
    github: "https://github.com/mcmullinboy15/trail_tracker",
    relatedExperience: [],
    relatedCourses: ["cs3200"],
    featured: false,
  },
  {
    id: "final-ml-code",
    title: "Final-ML-Code",
    category: "Machine Learning",
    year: "2022",
    description: "EECS 545 project repo.",
    tags: ["ai-ml"],
    github: "https://github.com/mcmullinboy15/Final-ML-Code",
    relatedExperience: [],
    relatedCourses: ["eecs545"],
    featured: false,
  },
  {
    id: "eecs587-project",
    title: "EECS 587 Project",
    category: "Parallel Computing",
    year: "2021",
    description: "Project work for EECS 587.",
    tags: ["systems-engineering"],
    github: "https://github.com/mcmullinboy15/587-project",
    relatedExperience: [],
    relatedCourses: ["eecs587"],
    featured: false,
  },
  {
    id: "pse-financial-display",
    title: "PSE Financial Display",
    category: "Internal Tooling",
    year: "2023",
    description:
      "Company financial display for project and revenue tracking (Flask + Vue.js).",
    tags: ["full-stack", "backend"],
    relatedExperience: ["pse"],
    relatedCourses: [],
    featured: false,
  },
  {
    id: "spark-a-change",
    title: "Spark A Change",
    category: "Web Platform",
    year: "2024",
    description:
      "Built a multi-page web experience with a landing page, donate flow, and a trip portal for participant data submission.",
    tags: ["full-stack", "frontend"],
    github: "https://github.com/mcmullinboy15/spark-a-change",
    link: "https://sparkachange.org/",
    relatedExperience: ["freelance"],
    relatedCourses: [],
    featured: false,
    order: 1,
  },
  {
    id: "podflow",
    title: "Podflow",
    category: "AI Content Tooling",
    year: "2023",
    description:
      "AI workflow that turns podcast audio/video into SEO show notes, transcripts, blog articles, quotes, titles, and social media content.",
    tags: ["ai-ml", "full-stack", "data-systems"],
    link: "https://www.podflow.ai/",
    relatedExperience: ["freelance"],
    relatedCourses: [],
    featured: false,
    order: 2,
  },
  {
    id: "prc-links",
    title: "PRC Links",
    category: "Education Platform",
    year: "2023",
    description:
      "Built an educational platform for Planar Linkage Synthesis with training videos, textbook resources, and guided PRC learning.",
    tags: ["frontend", "full-stack"],
    link: "https://prclinks.com",
    relatedExperience: ["freelance"],
    relatedCourses: [],
    featured: false,
    order: 3,
  },
  {
    id: "supra-seed-calculator",
    title: "Supra Seed Calculator",
    category: "AgriTech Tooling",
    year: "2023",
    description:
      "Built a seed rate calculator that converts acres, row spacing, seed type, and seeding method into lbs/acre and total lbs needed.",
    tags: ["frontend", "full-stack"],
    link: "https://beta-supra-ag.web.app",
    relatedExperience: ["freelance"],
    relatedCourses: [],
    featured: false,
  },];
